// This file is auto-generated by scripts/generate-version.js
// Do not edit manually - it will be overwritten on build

export const version = {
  gitCommit: '2b063e58f',
  buildTime: '2026-11-03T16:53:32.976Z',
} as const;
